module.exports = __webpack_public_path__ + "static/media/equipe-empresa.3d353c03.jpg";